import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AuthenticationProvider, I18nProvider } from './hooks';

if (process.env.REACT_APP_ENV === 'production') {
    Sentry.init({
        dsn: 'https://83e6f16bc0a34d589cf45080284544d4@o230677.ingest.sentry.io/6488349',
        integrations: [ new BrowserTracing() ],
        tracesSampleRate: 1.0,
    });
}

ReactDOM.render(
    <React.StrictMode>
        <AuthenticationProvider>
            <I18nProvider>
                <BrowserRouter>
                    <App/>
                </BrowserRouter>
            </I18nProvider>
        </AuthenticationProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
